import { OutgoingOrganizationMemberDto } from 'api/dtos/organizations/members';
import bounceApiClient from 'legacy/common/utils/bounceApiClient';

export async function joinOrganization({
  organizationId
}: {
  organizationId: string;
}): Promise<OutgoingOrganizationMemberDto> {
  const { data } = await bounceApiClient({
    method: 'post',
    url: `/api/organizations/${organizationId}/members`,
    data: {
      organizationId
    }
  });

  return data;
}

export async function exportOrganizationMembersCSV(
  organizationId: string
): Promise<Blob> {
  const { data } = await bounceApiClient.get(
    `/api/organizations/${organizationId}/members/export`,
    { responseType: 'blob' }
  );
  return data;
}
